import { ActiveParticipantEditDialog } from "@/pages/system-settings/tabs/proceeding-participants/components/edit-participant/active-participant-edit-dialog/ActiveParticipantEditDialog";
import { InactiveParticipantViewDialog } from "@/pages/system-settings/tabs/proceeding-participants/components/edit-participant/inactive-participant-view-dialog/InactiveParticipantViewDialog";

import { useParticipantEdit } from "./hooks/useParticipantEdit";

interface Props {
  participantId: string;
  onClose: () => void;
}

export function ParticipantEditDialog({ participantId, onClose }: Props) {
  const { formik, isLoading, lastChangedText, participant } = useParticipantEdit(participantId, onClose);

  if (participant != null && !participant.isActive) {
    return (
      <InactiveParticipantViewDialog
        participantId={participantId}
        participantName={participant.name}
        deactivatedAtUtc={participant.deactivatedAtUtc}
        deactivationReason={participant.deactivationReason ?? null}
        deactivatedByUserCode={participant.deactivatedByUserCode ?? null}
        mergeHistory={participant.mergeHistory ?? null}
        formik={formik}
        onClose={onClose}
      />
    );
  }

  return (
    <ActiveParticipantEditDialog
      participantId={participantId}
      participantName={participant?.name ?? ""}
      formik={formik}
      isLoading={isLoading}
      hasParticipant={participant != null}
      lastChangedText={lastChangedText}
      mergeHistory={participant?.mergeHistory ?? null}
      onClose={onClose}
    />
  );
}
